export class LiveEvent {
    public id: string;
    public name: string;
    public liveEventUrl: string;
    public startDateTime: Date;
    public endDateTime: Date;

    public deserialize(json: any): LiveEvent {
        const data: any = json.data || json;
        this.id = data.id;
        this.name = data.title;
        this.liveEventUrl = data.live_event_url;
        this.startDateTime = new Date(data.start_date_time);
        this.endDateTime = new Date(data.end_date_time);
        return this;
    }
}
